"use client";

import VideoPlayer from "rivals/components/shared/VideoPlayer";
import BrightcovePlayer from "rivals/components/shared/VideoPlayer/BrightcovePlayer";
import { VIDEO_PROVIDERS } from "rivals/shared/constants";
import styles from "./VideoBlock.module.scss";
import { Props } from "./types";

function VideoBlock({
  autoplay,
  blockId,
  brightcoveVideosOnScreen,
  contentSpaceId,
  currentBrightcoveVideoBlockId,
  hasEmbedConsent,
  remoteId,
  setBrightcoveVideosOnScreen,
  source,
  userCountry
}: Props): React.JSX.Element {
  return (
    <div className={styles.videoContainer}>
      {source === VIDEO_PROVIDERS.brightcove.source ? (
        <BrightcovePlayer
          autoplay={autoplay}
          blockId={blockId}
          contentSpaceId={contentSpaceId}
          currentVideoBlockId={currentBrightcoveVideoBlockId}
          hasEmbedConsent={!!hasEmbedConsent}
          philter={`video-${remoteId}-${source}`}
          setVideosOnScreen={setBrightcoveVideosOnScreen}
          srcId={remoteId}
          srcProvider={source}
          userCountry={userCountry}
          videosOnScreen={brightcoveVideosOnScreen}
        />
      ) : (
        <VideoPlayer
          autoplay={autoplay}
          autoplayOnHover={false}
          hasEmbedConsent={!!hasEmbedConsent}
          philter={`video-${remoteId}-${source}`}
          srcId={remoteId}
          srcProvider={source}
        />
      )}
    </div>
  );
}

export default VideoBlock;
